import React from "react";
import { useApp } from "@/context/AppContext";
import logo from "@/assets/eii-logo.jpg";
import { Globe } from "lucide-react";

export function LangSwitcher() {
  const { lang, changeLang } = useApp();
  return (
    <div
      className="flex items-center gap-1 rounded-full border border-border bg-card px-1 py-1 text-sm"
      data-testid="lang-switcher"
    >
      <Globe className="ml-1 h-4 w-4 text-muted-foreground" strokeWidth={1.5} />
      {["de", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => changeLang(l)}
          className={`rounded-full px-3 py-1 font-medium uppercase transition-colors ${
            lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}

export function Brand({ small }) {
  const { t } = useApp();
  return (
    <div className="flex items-center gap-3" data-testid="brand">
      <img src={logo} alt="Equi-Integral-International" className={small ? "h-10 w-10 rounded-full object-cover" : "h-14 w-14 rounded-full object-cover"} />
      <div className="leading-tight">
        <div className={`font-serif-h font-semibold text-primary ${small ? "text-base" : "text-lg"}`}>
          Equi-Integral
        </div>
        {!small && <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">International</div>}
      </div>
    </div>
  );
}
